<template>
    <div>
        <!-- SECTION #1: HERO -->
        <section class="section-hero section-shaped my-0">
            <div class="shape shape-style-1 shape-primary">
            </div>
            <div class="ml-lg-8 ml-md-5 ml-4 mr-4 mr-lg-0 mr-md-5 pt-7 shape-container d-flex">
                <div class="row">
                    <div class="col-lg-5 col-md-12 col-xs-12 col-sm-12 px-0 mt-5 pt-5 mr-xs-2 mr-sm-2">
                        <h1 class="display-2  text-secondary display-sm-4" style="font-family: Helvetica Neue">Arrange Virtual Ensembles 
                            with Automation.</h1>
                        <p class="lead  text-white">Skip the high fees, long editing time, and complicated 
                            production. Create your virtual ensemble recording with a single click.</p>
                        <div>
                            <badge type="white" class="bg-tertiary" rounded>Customized</badge>
                            <badge type="white" class="bg-tertiary" rounded>Affordable</badge>
                            <badge type="white" class="bg-tertiary" rounded>Quick</badge>
                        </div>
                        <div class="btn-wrapper mt-5 mb-5">
                            <base-button tag="a"
                                            href="/pricing"
                                            class="mb-3 mb-sm-0"
                                            type="default"
                                            icon="fa fa-edit">
                                Create Now
                            </base-button>
                        </div>
                    </div>         
                    <div class="col-lg-6 text-center mt-5 pt-5 d-xs-none d-lg-inline">
                        <img src="../assets/media/macbook-mockup.png"
                        class="img-fluid pt-4 d-none d-lg-inline">
                    </div>
                </div>
            </div>
        </section>

<!-- SECTION #2: CARD WITH STATS -->
        <!-- <section class="section section-lg pt-lg-0 mt--100">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12">
                        <div class="row row-grid">
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-check-bold" type="primary" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-primary text-uppercase">Download Argon</h6>
                                    <p class="description mt-3">Argon is a great free UI package based on Bootstrap 4
                                        that includes the most important components and features.</p>
                                    <div>
                                        <badge type="primary" rounded>design</badge>
                                        <badge type="primary" rounded>system</badge>
                                        <badge type="primary" rounded>creative</badge>
                                    </div>
                                    <base-button tag="a" href="#" type="primary" class="mt-4">
                                        Learn more
                                    </base-button>
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-istanbul" type="success" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-success text-uppercase">Build Something</h6>
                                    <p class="description mt-3">Argon is a great free UI package based on Bootstrap
                                        4 that includes the most important components and features.</p>
                                    <div>
                                        <badge type="success" rounded>business</badge>
                                        <badge type="success" rounded>vision</badge>
                                        <badge type="success" rounded>success</badge>
                                    </div>
                                    <base-button tag="a" href="#" type="success" class="mt-4">
                                        Learn more
                                    </base-button>
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-planet" type="warning" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-warning text-uppercase">Prepare Launch</h6>
                                    <p class="description mt-3">Argon is a great free UI package based on Bootstrap
                                        4 that includes the most important components and features.</p>
                                    <div>
                                        <badge type="warning" rounded>marketing</badge>
                                        <badge type="warning" rounded>product</badge>
                                        <badge type="warning" rounded>launch</badge>
                                    </div>
                                    <base-button tag="a" href="#" type="warning" class="mt-4">
                                        Learn more
                                    </base-button>
                                </card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section> -->

        <!-- SECTION #3: DESCRIPTION -->
        <section class="section section-lg">
            <div class="container">

                <!-- Large -->
                <div class="row mb-5 align-self-start show-on-lg no-show-on-sm">
                    <div class="col text-center align-self-start">
                        <icon name="fa fa-music" class=" align-items-center align-self-start bg-default" size="lg" type="white" shadow
                                  rounded></icon>
                        <span class="display-1 text-default" style="font-family: Helvetica Neue">  By Musicians, For Musicians</span>
                    </div>
                </div>

                <!-- Small -->
                <div class="row mb-5 align-self-start show-on-sm no-show-on-lg">
                    <div class="col text-center align-self-start">
                        <icon name="fa fa-music" class=" align-items-center align-self-start bg-default" size="md" type="white" shadow
                                  rounded></icon>
                        <span class="display-4 text-default" style="font-family: Helvetica Neue">  By Musicians, For Musicians</span>
                    </div>
                </div>

                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-md-2">
                        <img src="graphic.png" style="min-width: 100%" class="img-fluid floating">
                    </div>
                    <div class="col-md-6 pl-md-5 order-md-1">
                        <div class="pr-md-5">
                            <p>Our <strong class="text-default">completely automated </strong> virtual ensemble editor was born out of the setbacks that COVID-19 had brought
                                to musicians and music educators. With live performance out of question, virtual ensemble recordings were the solution. However, this came at a high price with 
                                some video editors <strong class="text-default"> charging up to $1000 per video</strong>: impossible to fund for many fine arts programs.
                            </p>
                            <ul class="list-unstyled mt-5">
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="tertiary" circle class="mr-3" icon="fa fa-check"></badge>
                                        <h6 class="mb-0">Budget Friendly</h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="tertiary" circle class="mr-3" icon="fa fa-check"></badge>
                                        <h6 class="mb-0">Client-First</h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="tertiary" circle class="mr-3" icon="fa fa-check"></badge>
                                        <h6 class="mb-0">Hands-Free</h6>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

                <!-- LARGE VERSION -->
                <card gradient="lighter"
                      no-body
                      shadow-size="lg"
                      class="border-0 mx-9 mt-7">
                    <div class="row align-items-center pt-5 show-on-lg no-show-on-sm">
                        <div class="col text-center">
                            <div class="col text-center align-self-start">
                                <span class="display-2 text-default" style="font-family: Helvetica Neue">How To Use Amadeus</span>
                            </div>
                            <iframe width="90%" height="640" src="https://www.youtube.com/embed/9fZOJzR4I54" 
                            frameborder="0" 
                            class="mt-5 mb-5"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                            allowfullscreen></iframe>
                        </div>
                    </div>
                </card>

                <!-- SMALL VERSION -->
                <card gradient="lighter"
                      no-body
                      shadow-size="lg"
                      class="border-0 mx-2">
                    <div class="row align-items-center pt-5 show-on-sm no-show-on-lg">
                        <div class="col text-center">
                            <div class="col text-center align-self-start">
                                <span class="display-2 text-default" style="font-family: Helvetica Neue">How To Use Amadeus</span>
                            </div>
                            <iframe width="90%" height="320" src="https://www.youtube.com/embed/9fZOJzR4I54" 
                            frameborder="0" 
                            class="mt-5 mb-5"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                            allowfullscreen></iframe>
                        </div>
                    </div>
                </card>
        </section>


        <!-- SECTION #4: HOW-TO -->
        <section class="section section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-1 shape-default shape-skew">
            </div>
            <div class="container">

                <!--  Large -->
                <div class="row justify-content-center text-center mb-lg show-on-lg no-show-on-sm mt-4">
                    <div class="row mb-3 align-self-start">
                        <div class="col text-center align-self-start mt-2">
                            <icon name="ni ni-settings" class=" align-items-center align-self-start bg-white" size="lg" type="primary" shadow
                                  rounded></icon>
                            <span class="display-1 text-white" style="font-family: Helvetica Neue"> Completed in 3 Steps</span>
                        </div>
                    </div>
                </div>

                    <!-- Small -->
                <div class="row justify-content-center text-center mb-lg show-on-sm no-show-on-lg mt-4">
                    <div class="row mb-3 align-self-start">
                        <div class="col text-center align-self-start mt-1">
                            <icon name="ni ni-settings" class=" align-items-center align-self-start bg-white" size="md" type="primary" shadow
                                  rounded></icon>
                            <span class="display-4 text-white" style="font-family: Helvetica Neue"> Completed in 3 Steps</span>
                        </div>
                    </div>
                </div>

                
                <div class="row row-grid align-items-center justify-content-center">
                    <div class="col-lg-6 order-lg-2">
                        <card shadow class="shadow-lg--hover mt-5">
                            <div class="d-flex px-3">
                                <div>
                                    <icon name="fa fa-video-camera" gradient="tertiary" color="white" shadow
                                        rounded></icon>
                                </div>
                                <div class="pl-4">
                                    <h5 class="title text-tertiary"><strong>STEP 1:</strong> Record with a Clap</h5>
                                    <p class="text-default">Instruct musicians to clap a set time period before playing at beginning of their recording. Our algorithm will 
                                        use this as a benchmark to align the music in each individual clip.
                                    </p>
                                </div>
                            </div>
                        </card>
                    </div>
                </div>
                <div class="row row-grid align-items-center justify-content-center">
                    <div class="col-lg-6 order-lg-1">
                        <card shadow class="shadow-lg--hover mt-5">
                            <div class="d-flex px-3">
                                <div>
                                    <icon name="ni ni-cloud-upload-96" gradient="tertiary" color="white" shadow
                                        rounded></icon>
                                </div>
                                <div class="pl-4">
                                    <h5 class="title text-tertiary"><strong>STEP 2:</strong> Upload Videos</h5>
                                    <p class="text-default">Upload all videos of individual recordings to Amadeus via our in-house editing portal.
                                                             Our simple interface allows for quick project creation with ease.
                                    </p>
                                </div>
                            </div>
                        </card>
                    </div>
                </div>
                <div class="row row-grid align-items-center justify-content-center">
                    <div class="col-lg-6">
                        <card shadow class="shadow-lg--hover mt-5">
                            <div class="d-flex px-3">
                                <div>
                                    <icon name="fa fa-play" gradient="tertiary" color="white" shadow
                                        rounded></icon>
                                </div>
                                <div class="pl-4">
                                    <h5 class="title text-tertiary"><strong>STEP 3:</strong> Generate Virtual Ensemble</h5>
                                    <p class="text-default">With the press of a button, Amadeus will queue your request to generate a 
                                        virtual ensemble video, which will be ready for download in 24-48 hours.
                                    </p>
                                </div>
                            </div>
                        </card>
                    </div>
                </div>
            </div>
        </section>







        <section class="section section-lg pt-5 pb-0">
            <div class="container">
                <!-- Large -->
                <div class="row justify-content-center text-center mb-lg show-on-lg no-show-on-sm">
                    <div class="row mb-3 align-self-start">
                        <div class="col text-center align-self-start">
                            <icon name="fa fa-user" class=" align-items-center align-self-start bg-default" size="lg" type="white" shadow
                                  rounded></icon>
                            <span class="display-1 text-default" style="font-family: Helvetica Neue"> Meet the Developer</span>
                        </div>
                    </div>
                    <div class='row text-center justify-content-center'>
                        <div class="col-lg-8 text-center">
                            <h4 class="text-center lead mt-0 mb-4 font-weight-bold">Student. Programmer. Violist. Composer.</h4>
                            <!-- <p class="lead mb-5">Hey, I'm Thomas, a computer science major at Rice University. As a composer myself, I also experienced the frustrating
                                                            reality of putting together virtual ensemble recordings. Hiring an editor is expensive and diy-ing your own version 
                                                            requires an ungodly amount of time. With music educators mainly using such virtual ensembles
                                                            videos for performances to continue providing an immersive music education for students, I wanted to make this process just 
                                                            a little bit easier for everyone.
                            </p> -->
                        </div>
                    </div>
                </div>

                    <!-- Small -->
                <div class="row justify-content-center text-center mb-lg show-on-sm no-show-on-lg">
                    <div class="row mb-3 align-self-start">
                        <div class="col text-center align-self-start">
                            <icon name="fa fa-user" class=" align-items-center align-self-start bg-default" size="md" type="white" shadow
                                  rounded></icon>
                            <span class="display-4 text-default" style="font-family: Helvetica Neue"> Meet the Developer</span>
                        </div>
                    </div>
                    <div class="col-lg-8">
                        <h4 class="lead mt-0 mb-4 font-weight-bold">Student. Programmer. Violist. Composer.</h4>
                        <!-- <p class="lead mb-5">Hey, I'm Thomas, a computer science major at Columbia University. As a composer myself, I also experienced the frustrating
                                                        reality of putting together virtual ensemble recordings. Hiring an editor is expensive and diy-ing your own version 
                                                        requires an ungodly amount of time. With music educators mainly using such virtual ensembles
                                                        videos for performances to continue providing an immersive music education for students, I wanted to make this process just 
                                                        a little bit easier for everyone.
                        </p> -->
                    </div>
                </div>


                <div class="col-md-6 mr-md-auto ml-md-auto">
                    <div class="justify-content-center">
                        <img src="img/thomas_yeum.jpg" class="shadow shadow-lg--hover rounded-circle img-center img-fluid"
                                style="width: 250px;">
                    </div>
                    <div class="pt-4 text-center">
                        <h5 class="title">
                            <span class="d-block mb-1">Thomas Yeum</span>
                            <small class="h6 text-muted">Founder, Developer</small>
                        </h5>
                        <div class="col mt-3">
                            <div class="justify-content-center align-items-center text-center btn-wrapper">
                                <a target="_blank" rel="noopener" href="https://www.linkedin.com/in/yeumthomas/"
                                class="rounded-circle btn btn-neutral btn-icon-only btn-twitter btn-round btn-lg" data-toggle="tooltip"
                                data-original-title="">
                                    <i class="fa fa-linkedin"></i>
                                </a>
                                <a target="_blank" rel="noopener" href="https://www.facebook.com/yeumthomas"
                                class="rounded-circle btn btn-neutral btn-icon-only btn-facebook btn-round btn-lg" data-toggle="tooltip"
                                data-original-title="">
                                    <i class="fa fa-facebook-square"></i>
                                </a>
                                <a target="_blank" rel="noopener" href="https://www.instagram.com/thomasyeum/?hl=en"
                                class="rounded-circle btn btn-neutral btn-icon-only btn-instagram btn-lg btn-round" data-toggle="tooltip"
                                data-original-title="">
                                    <i class="fa fa-instagram"></i>
                                </a>
                                <a target="_blank" rel="noopener" href="https://www.youtube.com/channel/UCk3xwqtCowaHghNkaZoIogw"
                                class="rounded-circle btn btn-neutral btn-icon-only btn-youtube btn-round btn-lg" data-toggle="tooltip"
                                data-original-title="">
                                    <i class="fa fa-youtube"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-center text-center mb-3 px-2">
                    <div class="col-lg-9 pt-5 px-0">
                        <p class="text-center mb-5">Hey, I'm Thomas, a computer science major at Columbia University. As a composer myself, I also experienced the frustrating
                                                        reality of putting together virtual ensemble recordings. Hiring an editor is expensive and diy-ing your own version 
                                                        requires an ungodly amount of time. With music educators mainly using such virtual ensembles
                                                        videos for performances to continue providing an immersive music education for students, I wanted to make this process just 
                                                        a little bit easier for everyone.
                        </p>
                    </div>
                </div>
            </div>
        </section>



        <section class="section section-lg pt-0">
            <div class="container">
                <card gradient="tertiary"
                      no-body
                      shadow-size="lg"
                      class="border-0">
                    <div class="p-5">
                        <div class="row align-items-center">
                            <div class="col-lg-8">
                                <h3 class="text-white">We made making virtual ensembles easier.</h3>
                                <p class="lead text-white mt-3">With the orchestras, choirs, bands in mind, we provide 
                                    a by-musicians-for-musicians experience to simplify this process. We hope you 
                                    enjoy it!</p>
                            </div>
                            <div class="col-lg-3 ml-lg-auto">
                                <base-button tag="a" href="/pricing"
                                             type="white" block size="lg">
                                    View Pricing
                                </base-button>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>

    </div>
</template>

<script>
import Images from './components/JavascriptComponents/Images.vue';
export default {
  name: "home",
  components: {Images}
};
</script>

<style scoped>

@media (max-width: 768px) {
    .smaller-title {
        font-size: 10px !important;
    }
    .show-on-sm {
        display: inline !important;
    }

    .no-show-on-sm {
        display: none !important;
    }
}

@media (min-width: 769px) {
    .smaller-title {
        font-size: 10px !important;
    }
    .show-on-lg {
        display: inline !important;
    }

    .no-show-on-lg {
        display: none !important;
    }
}

</style>
